import RepertoriTable from './RepertoriTable';
export default RepertoriTable;